import { isNotNullOrEmptyString, isTenantEntityActive } from '../../shared/utils/functions';
import {
  EDPAvailabilityInfo,
  EDPLeaseCompInfo,
  EDPSpaceInfo,
  EDPTenantInfo,
} from '../../stacking-plan-container/floor-container/floor/item/item.model';
import { AbstractSpaceClass, SpaceClassOptions } from './abstract-space.class';
import { AvailabilitySpaceClass } from './availability-space.class';
import { NonRentableSpaceClass } from './non-rentable-space.class';
import { TenantSpaceClass } from './tenant-space.class';

export interface SpacesAndInactiveFlag {
  spaces: AbstractSpaceClass[];
  anyInactive: boolean;
}

export class SpaceClass {
  static fromEDPSpaceInfo(edpSpaceInfo: EDPSpaceInfo, options: Partial<SpaceClassOptions>): SpacesAndInactiveFlag {
    let abstractSpaceClass: AbstractSpaceClass[] = [];
    if (this.isTenant(edpSpaceInfo)) {
      abstractSpaceClass.push(new TenantSpaceClass(edpSpaceInfo, options));
    } else if (this.isAvailability(edpSpaceInfo)) {
      abstractSpaceClass.push(new AvailabilitySpaceClass(edpSpaceInfo, options));
    } else if (!!edpSpaceInfo.non_rentable_space) {
      abstractSpaceClass.push(new NonRentableSpaceClass(edpSpaceInfo, options));
    }
    return { spaces: abstractSpaceClass, anyInactive: this.isInactiveSpace(edpSpaceInfo) };
  }

  static filterOutInvalidSpaces(edpSpaceInfo: EDPSpaceInfo[]): EDPSpaceInfo[] {
    return (
      edpSpaceInfo?.filter(space => {
        const { availability, tenant, non_rentable_space, lease } = space;
        const isSpaceEmpty = Object.values(space).every(
          val => val == null || ((typeof val === 'string' || typeof val === 'number') && !isNotNullOrEmptyString(val))
        );
        const isSpaceInvalid =
          availability == null &&
          (isTenantEntityActive() ? tenant == null : lease == null) &&
          non_rentable_space == null;
        return !isSpaceEmpty && !isSpaceInvalid;
      }) || []
    );
  }

  private static isTenant(edpSpaceInfo: EDPSpaceInfo): boolean {
    if (isTenantEntityActive()) {
      return !!edpSpaceInfo.tenant && this.checkActiveFlag(edpSpaceInfo.tenant);
    }
    return !!edpSpaceInfo.lease && this.checkActiveFlag(edpSpaceInfo.lease);
  }

  private static isAvailability(edpSpaceInfo: EDPSpaceInfo): boolean {
    return !!edpSpaceInfo.availability && this.checkActiveFlag(edpSpaceInfo.availability);
  }

  private static checkActiveFlag(spaceWActiveF: EDPTenantInfo | EDPLeaseCompInfo | EDPAvailabilityInfo): boolean {
    return spaceWActiveF.active_f && !spaceWActiveF.miq_record_hide_f;
  }

  private static isInactiveSpace(edpSpaceInfo: EDPSpaceInfo) {
    const { availability, tenant } = edpSpaceInfo;
    return (!!availability && !this.checkActiveFlag(availability)) || (!!tenant && !this.checkActiveFlag(tenant));
  }
}
